import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { GoogleIcon } from './GoogleIcon';

export default createWebRegistration({
  authProviders: {
    google: {
      icon: GoogleIcon,
      benefit: 'Enables Google-based authentication',
    },
  },
});
